import { isEmpty, isString } from 'lodash';
import {
  CountryCode,
  parsePhoneNumberFromString as parsePhoneNumber,
} from 'libphonenumber-js/max';
import React from 'react';

export function validateMobileNumber(
  value: unknown,
  country?: CountryCode,
  invalidPhoneAlert?: string | React.ReactNode | React.ReactNode[],
): boolean | string | React.ReactNode | React.ReactNode[] {
  if (!value || isEmpty(value) || !isString(value)) return false;

  let phoneNumber;
  if (country) {
    phoneNumber = parsePhoneNumber(value, country);
  } else {
    // Default to US > BR
    phoneNumber = parsePhoneNumber(value, 'US');
    if (!phoneNumber || !phoneNumber.isValid()) {
      phoneNumber = parsePhoneNumber(value, 'BR');
    }
  }
  return phoneNumber && phoneNumber.isValid()
    ? false
    : invalidPhoneAlert || 'Not a valid mobile phone number';
}
